import { render } from "./shop-the-look-collage.vue?vue&type=template&id=456e2b22"
import script from "./shop-the-look-collage.vue?vue&type=script&lang=js"
export * from "./shop-the-look-collage.vue?vue&type=script&lang=js"

import "./shop-the-look-collage.vue?vue&type=style&index=0&id=456e2b22&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__